import React from 'react';
import { Grid, Card, CardContent, Typography, Skeleton, Box } from '@mui/material';
import { fontSize, fontWeight } from '../../utils/accounting/styles';
import { formatCurrency } from '../../utils/accounting/formatters';

const SummaryCardGrid = ({ cards = [], loading = false, sx = {} }) => {
  return (
    <Grid container spacing={1.5} sx={sx}>
      {cards.map((card, i) => (
        <Grid item xs={6} sm={6} md={3} key={i}>
          <Card
            variant="outlined"
            sx={{
              cursor: card.onClick ? 'pointer' : 'default',
              '&:hover': card.onClick ? { borderColor: `${card.color || 'primary'}.main`, transform: 'translateY(-1px)' } : {},
              transition: 'all 0.15s',
            }}
            onClick={card.onClick}
          >
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
              <Typography
                sx={{ fontSize: '0.65rem', fontWeight: fontWeight.medium, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.04em', mb: 0.25 }}
              >
                {card.label}
              </Typography>
              {loading ? (
                <Skeleton width="60%" height={24} />
              ) : (
                <Typography
                  sx={{ fontSize: fontSize.md, fontWeight: fontWeight.bold, color: card.color ? `${card.color}.main` : 'text.primary' }}
                >
                  {card.suffix ? `${card.value} ${card.suffix}` : formatCurrency(card.value)}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCardGrid;
